import { InertiaLink } from '@inertiajs/inertia-react'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'

export default function HeaderComponent() {
  const { t } = useTranslation()

  return (
    <Button
      component={InertiaLink}
      color="inherit"
      sx={{ color: 'black' }}
      href={route('merchant.vouchers.create')}
      variant="contained"
    >
      {t('BUTTON.ADD_VOUCHER')}
    </Button>
  )
}
